//core
import React, {useCallback, useState} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Delete,
  Edit,
  Visibility,
} from '@mui/icons-material';

//hooks
import { usePermissions } from "../../../../../store/common/configuration/usePermissions";

//routes
import routes from "../../../../../navigation/routes";

//components
import ActionIconButton from "../../../../UI/Buttons/ActionIconButton";
import MuiModal from "../../../../UI/MuiModal";
import DeleteDeal from "../DeleteDeal";

import { itemListData } from "../../../../common/TableData";
export interface ITableActions {
  id: string | number;
  data: itemListData;
}

const TableActions: React.FC<ITableActions> = ({
  id,
  data,
}): JSX.Element => {
  const { t } = useTranslation();
  let history = useNavigate();
  const { hasPermissions } = usePermissions();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const hasDelete = hasPermissions(["api3.admin.subaffiliatedealcontroller.delete"]);
  const hasEdit = hasPermissions(["api3.admin.subaffiliatedealcontroller.update"]);

  const handleToggleShowDeleteModal = useCallback((state: boolean) => {
    setShowDeleteModal(state);
  }, [setShowDeleteModal]);

  const handleShowDetailsDeal = useCallback(() => {
    history(routes.admin.sub_aff_deals_v2.details.replace(':id', `${id}`));
  }, [id]);

  const handleEditDeal = useCallback(() => {
    history(routes.admin.sub_aff_deals_v2.edit.replace(':id', `${id}`));
  }, [id]);

  const editBtn = <ActionIconButton
	  text={t("common.buttons.edit")}
	  icon={<Edit fontSize="small" color={'primary'}/>}
	  onClick={handleEditDeal}
	  disabled={data.isReadOnly}
  />

	const detailsBtn = <ActionIconButton
		text={t("common.buttons.details")}
		icon={<Visibility fontSize="small" color={'primary'}/>}
		onClick={handleShowDetailsDeal}
	/>

  const deleteBtn = <ActionIconButton
    text={t("common.buttons.delete")}
    icon={<Delete fontSize="small" color={'primary'}/>}
    onClick={() => handleToggleShowDeleteModal(true)}
    disabled={data.isReadOnly}
  />

  return (
    <>
      {/*Details*/}
	    {detailsBtn}

      {/*Edit*/}
      {hasEdit && editBtn}

      {/*Delete*/}
      {hasDelete && deleteBtn}

      {/* Delete modal */}
      <MuiModal
        width={472}
        open={showDeleteModal}
        closeOnOutside={false}
        setToggleModal={handleToggleShowDeleteModal}
      >
        <DeleteDeal
          id={data.id}
          setToggleModal={handleToggleShowDeleteModal}
        />
      </MuiModal>
    </>
  );
};

export default TableActions;
